// Customize the VS theme to make comments lighter and adjust colors
export const customStyle = {
  'comment': {
    color: '#999'
  },
  'function': {
    color: '#444'
  },
  'keyword': {
    color: '#000080'
  },
  'string': {
    color: '#008000'
  },
  'number': {
    color: '#0000ff'
  },
  'class-name': {
    color: '#800080'
  },
  'operator': {
    color: '#666'
  }
};